import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Navigation, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SSO_SIGN_OUT_MSG } from '../constants/storage-constants';

export const errorMessageResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<string> => {
  const router = inject(Router);
  const currentNav: Navigation = router.getCurrentNavigation();
  const routeData: { message: string } = currentNav?.extras?.state as { message: string };

  if (routeData?.message) {
    return of(routeData.message);
  }

  const message: string = localStorage.getItem(SSO_SIGN_OUT_MSG);

  return of(message ? message : 'ALERT_PAGE.DEFAULT_ERROR');
};
